var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRescived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.725,
    height: 29.725,
    viewBox: "0 0 29.725 29.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7170",
    "data-name": "Group 7170",
    transform: "translate(-309.138 -213.137)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_289",
    "data-name": "Ellipse 289",
    cx: 13.843,
    cy: 13.843,
    r: 13.843,
    transform: "translate(310.139 214.174) rotate(-0.073)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_289_-_Outline",
    "data-name": "Ellipse 289 - Outline",
    d: "M13.843-1a14.843,14.843,0,0,1,10.5,25.339A14.843,14.843,0,0,1,3.348,3.348,14.746,14.746,0,0,1,13.843-1Zm0,27.687A12.843,12.843,0,1,0,1,13.843,12.858,12.858,0,0,0,13.843,26.687Z",
    transform: "translate(310.139 214.174) rotate(-0.073)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRescived);
export default __webpack_public_path__ + "static/media/rescived.9426ac1ee732e8ee7a8ecc346781f63e.svg";
export { ForwardRef as ReactComponent };